export const PC_PAGE_CONFIG = {
  "title": "Event Analysis",
  "titleCN": "事件分析",
  "subTitle": "",
  "subTitleCN": "",
  "path": "/eventAnalysis/eventAnalysis",
  "defaultTab": "overall",
  "tabList": [
    {
      "id": "overall",
      "tabName": "Overall",
      "tabNameCN": "总览",
      "isHaveNotification": true,
      "notificationPath": "/eventAnalysis/eventAnalysis",
      "path": "/eventAnalysis/eventAnalysis",
      "tabIcon": "chart-map",
      "logConfig": {
        "pageId": "205101",
        "pageName": "eventAnalysisEventAnalysis",
        "extInfo": "eventAnalysisEventAnalysis",
        "pagePath": "/eventAnalysis/eventAnalysis"
      },
      "filters": [
        {
          "name": "EventFilter",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "/eventAnalysis/eventAnalysis",
          "componentList": [
            {
              "name": "EventAnalysisTrendCo",
              "className": "margin-t-20",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "api": "/api/v1/dashboard/pc/event_analysis_v2/metrics_trend",
                  "eventApi": "/api/v1/dashboard/pc/event_analysis_v2/trend_event_list",
                  "haveMore": false,
                  "componentMetrics": [
                    {
                      "metricKey": "all_entitlement",
                      "reqMetricKey": "all_entitlement",
                      "enName": "Entitlement",
                      "cnName": "拥有游戏用户数",
                      "rainbowKey": "Pc Entitlement",
                      "type": "int",
                      "decimal": 0
                    },
                    {
                      "metricKey": "total_users",
                      "reqMetricKey": "total_users",
                      "enName": "TNU",
                      "cnName": "总注册用户数",
                      "rainbowKey": "Pc TNU",
                      "type": "int",
                      "decimal": 0
                    },
                    {
                      "metricKey": "new_users",
                      "reqMetricKey": "new_users",
                      "enName": "New",
                      "cnName": "新进用户",
                      "rainbowKey": "Pc New",
                      "type": "int",
                      "decimal": 0
                    },
                    {
                      "metricKey": "active_users",
                      "reqMetricKey": "active_users",
                      "enName": "DAU",
                      "cnName": "日活跃",
                      "rainbowKey": "Pc DAU",
                      "type": "int",
                      "decimal": 0
                    },
                    {
                      "metricKey": "net_revenue",
                      "reqMetricKey": "net_revenue",
                      "enName": "Revenue After Refund & Tax($)",
                      "cnName": "净收入($)",
                      "rainbowKey": "Pc Revenue",
                      "type": "decimals",
                      "decimal": 2
                    },
                    {
                      "metricKey": "revenue_after_chargeback",
                      "reqMetricKey": "revenue_after_chargeback",
                      "enName": "Revenue After Refund($)",
                      "cnName": "收入(剔除退款)($)",
                      "rainbowKey": "Pc Revenue After Refund($)",
                      "type": "decimals",
                      "decimal": 2
                    },
                    {
                      "metricKey": "units_number",
                      "reqMetricKey": "units_number",
                      "enName": "Base Game Units After Refund",
                      "cnName": "本体拷贝净销量",
                      "rainbowKey": "Pc Units",
                      "type": "int",
                      "decimal": 0
                    },
                    {
                      "metricKey": "gross_revenue",
                      "reqMetricKey": "gross_revenue",
                      "enName": "Revenue($)",
                      "cnName": "收入($)",
                      "rainbowKey": "Pc Gross Revenue",
                      "type": "decimals",
                      "decimal": 2
                    },
                    {
                      "metricKey": "gross_full_game_units",
                      "reqMetricKey": "gross_full_game_units",
                      "enName": "Gross Base Game Units",
                      "cnName": "本体销量",
                      "rainbowKey": "Pc Gross Base Game Units",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "units_revenue",
                      "reqMetricKey": "units_revenue",
                      "enName": "Base Game Revenue After Refund & Tax($)",
                      "cnName": "本体拷贝收入($)",
                      "rainbowKey": "Pc Units Revenue",
                      "type": "decimals",
                      "decimal": 2
                    },
                    {
                      "metricKey": "mtx_revenue",
                      "reqMetricKey": "mtx_revenue",
                      "enName": "In-Game Revenue($)",
                      "cnName": "内购收入($)",
                      "type": "decimals",
                      "decimal": 2
                    },
                    {
                      "metricKey": "paid_users",
                      "reqMetricKey": "paid_users",
                      "enName": "Payer",
                      "cnName": "付费人数",
                      "rainbowKey": "Pc Payer",
                      "type": "int",
                      "decimal": 0
                    },
                    {
                      "metricKey": "payer_rate",
                      "reqMetricKey": "payer_rate",
                      "enName": "Payer%",
                      "cnName": "付费渗透率",
                      "rainbowKey": "Pc Payer%",
                      "type": "percent",
                      "decimal": 2
                    },
                    {
                      "metricKey": "arpu",
                      "reqMetricKey": "arpu",
                      "enName": "ARPU($)",
                      "cnName": "活跃ARPU($)",
                      "type": "decimals",
                      "decimal": 2
                    },
                    {
                      "metricKey": "arppu",
                      "reqMetricKey": "arppu",
                      "enName": "ARPPU($)",
                      "cnName": "付费ARPPU($)",
                      "type": "decimals",
                      "decimal": 2
                    },
                    {
                      "metricKey": "mtx_payers",
                      "reqMetricKey": "mtx_payers",
                      "enName": "In-Game Payer",
                      "cnName": "内购付费人数",
                      "type": "int",
                      "decimal": 0
                    },
                    {
                      "metricKey": "mtx_payer_rate",
                      "reqMetricKey": "mtx_payer_rate",
                      "enName": "In-Game Payer%",
                      "cnName": "内购付费渗透率",
                      "type": "percent",
                      "decimal": 2
                    },
                    {
                      "metricKey": "mtx_arpu",
                      "reqMetricKey": "mtx_arpu",
                      "enName": "In-Game ARPU",
                      "cnName": "内购ARPU",
                      "type": "decimals",
                      "decimal": 2
                    },
                    {
                      "metricKey": "mtx_arppu",
                      "reqMetricKey": "mtx_arppu",
                      "enName": "In-Game ARPPU",
                      "cnName": "内购付费ARPPU",
                      "type": "decimals",
                      "decimal": 2
                    },
                    {
                      "metricKey": "digital_revenue",
                      "reqMetricKey": "digital_revenue",
                      "enName": "Digital Revenue",
                      "cnName": "线上收入",
                      "rainbowKey": "Pc Digital Revenue",
                      "type": "decimals",
                      "decimal": 2
                    },
                    {
                      "metricKey": "physical_revenue",
                      "reqMetricKey": "physical_revenue",
                      "enName": "Physical Revenue",
                      "cnName": "线上收入",
                      "rainbowKey": "Pc Physical Revenue",
                      "type": "decimals",
                      "decimal": 2
                    },
                    {
                      "metricKey": "d1",
                      "reqMetricKey": "d1",
                      "enName": "D1",
                      "cnName": "D1留存",
                      "rainbowKey": "Pc D1",
                      "type": "percent",
                      "decimal": 2
                    },
                    {
                      "metricKey": "d2",
                      "reqMetricKey": "d2",
                      "enName": "D2",
                      "cnName": "D2留存",
                      "rainbowKey": "Pc D2",
                      "type": "percent",
                      "decimal": 2
                    },
                    {
                      "metricKey": "d3",
                      "reqMetricKey": "d3",
                      "enName": "D3",
                      "cnName": "D3留存",
                      "rainbowKey": "Pc D3",
                      "type": "percent",
                      "decimal": 2
                    },
                    {
                      "metricKey": "d4",
                      "reqMetricKey": "d4",
                      "enName": "D4",
                      "cnName": "D4留存",
                      "rainbowKey": "Pc D4",
                      "type": "percent",
                      "decimal": 2
                    },
                    {
                      "metricKey": "d5",
                      "reqMetricKey": "d5",
                      "enName": "D5",
                      "cnName": "D5留存",
                      "rainbowKey": "Pc D5",
                      "type": "percent",
                      "decimal": 2
                    },
                    {
                      "metricKey": "d6",
                      "reqMetricKey": "d6",
                      "enName": "D6",
                      "cnName": "D6留存",
                      "rainbowKey": "Pc D6",
                      "type": "percent",
                      "decimal": 2
                    },
                    {
                      "metricKey": "d7",
                      "reqMetricKey": "d7",
                      "enName": "D7",
                      "cnName": "D7留存",
                      "rainbowKey": "Pc D7",
                      "type": "percent",
                      "decimal": 2
                    },
                    {
                      "metricKey": "d14",
                      "reqMetricKey": "d14",
                      "enName": "D14",
                      "cnName": "D14留存",
                      "rainbowKey": "Pc D14",
                      "type": "percent",
                      "decimal": 2
                    },
                    {
                      "metricKey": "d30",
                      "reqMetricKey": "d30",
                      "enName": "D30",
                      "cnName": "D30留存",
                      "rainbowKey": "Pc D30",
                      "type": "percent",
                      "decimal": 2
                    },
                    {
                      "metricKey": "pcu",
                      "reqMetricKey": "pcu",
                      "enName": "PCU",
                      "cnName": "最高同时在线",
                      "type": "int",
                      "decimal": 0
                    },
                    {
                      "metricKey": "acu",
                      "reqMetricKey": "acu",
                      "enName": "ACU",
                      "cnName": "平均同时在线",
                      "type": "int",
                      "decimal": 0
                    },
                    {
                      "metricKey": "aot_hour",
                      "reqMetricKey": "aot_hour",
                      "enName": "Avg.Playtime(h)",
                      "cnName": "平均在线时长(小时)",
                      "type": "decimals",
                      "decimal": 2
                    },
                    {
                      "metricKey": "alc",
                      "reqMetricKey": "alc",
                      "enName": "Sessions per user",
                      "cnName": "平均登录次数",
                      "rainbowKey": "Pc Metrics Session",
                      "type": "decimals",
                      "decimal": 2
                    },
                    {
                      "metricKey": "retention_users",
                      "reqMetricKey": "retention_users",
                      "enName": "DAU Retention Users",
                      "cnName": "日活留存",
                      "type": "int",
                      "decimal": 0
                    },
                    {
                      "metricKey": "churn_users",
                      "reqMetricKey": "churn_users",
                      "enName": "Churn Users",
                      "cnName": "日流失",
                      "type": "int",
                      "decimal": 0
                    },
                    {
                      "metricKey": "churn_rate",
                      "reqMetricKey": "churn_rate",
                      "enName": "Churn%",
                      "cnName": "流失率",
                      "type": "percent",
                      "decimal": 2
                    },
                    {
                      "metricKey": "return_users",
                      "reqMetricKey": "return_users",
                      "enName": "DAU Return Users",
                      "cnName": "日回流",
                      "type": "int",
                      "decimal": 0
                    },
                    {
                      "metricKey": "weighted_d2",
                      "reqMetricKey": "weighted_d2",
                      "enName": "Weighted D1",
                      "cnName": "加权D1留存",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 2
                    },
                    {
                      "metricKey": "weighted_d3",
                      "reqMetricKey": "weighted_d3",
                      "enName": "Weighted D2",
                      "cnName": "加权D2留存",
                      "type": "percent",
                      "decimal": 2
                    },
                    {
                      "metricKey": "weighted_d7",
                      "reqMetricKey": "weighted_d7",
                      "enName": "Weighted D6",
                      "cnName": "加权D6留存",
                      "type": "percent",
                      "decimal": 2
                    },
                    {
                      "metricKey": "weighted_d14",
                      "reqMetricKey": "weighted_d14",
                      "enName": "Weighted D13",
                      "cnName": "加权D13留存",
                      "type": "percent",
                      "decimal": 2
                    },
                    {
                      "metricKey": "first_login_ratio",
                      "reqMetricKey": "first_login_ratio",
                      "enName": "1st Order Login%",
                      "cnName": "一阶登录比",
                      "type": "percent",
                      "decimal": 2
                    },
                    {
                      "metricKey": "second_login_ratio",
                      "reqMetricKey": "second_login_ratio",
                      "enName": "2nd Order Login%",
                      "cnName": "二阶登录比",
                      "type": "percent",
                      "decimal": 2
                    }
                  ]
                }
              }
            },
            {
              "name": "EventTableCo",
              "className": "",
              "type": "view",
              "style": {
                "marginTop": "20px"
              },
              "props": {
                "config": {
                  "api": {
                    "tableApi": "/api/v1/dashboard/pc/event_analysis_v2/overall_performance",
                    "tableDownloadApi": "/api/v1/dashboard/pc/event_analysis_v2/overall_performance/download"
                  },
                  "componentMetrics": [
                    {
                      "metricKey": "all_entitlement",
                      "reqMetricKey": "all_entitlement",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 160,
                      "enWidth": 110,
                      "cnWidth": 130,
                      "enName": "Entitlement",
                      "cnName": "拥有游戏用户数",
                      "rainbowKey": "Pc Entitlement",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "total_users",
                      "reqMetricKey": "total_users",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 160,
                      "enWidth": 110,
                      "cnWidth": 130,
                      "enName": "TNU",
                      "cnName": "总注册用户数",
                      "rainbowKey": "Pc TNU",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "new_users",
                      "reqMetricKey": "new_users",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 160,
                      "enWidth": 110,
                      "cnWidth": 110,
                      "enName": "New",
                      "cnName": "新进用户",
                      "rainbowKey": "Pc New",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "active_users",
                      "reqMetricKey": "active_users",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 160,
                      "enWidth": 110,
                      "cnWidth": 110,
                      "enName": "DAU",
                      "cnName": "日活跃",
                      "rainbowKey": "Pc DAU",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "net_revenue",
                      "reqMetricKey": "net_revenue",
                      "enPercentWidth": 270,
                      "cnPercentWidth": 190,
                      "enWidth": 270,
                      "cnWidth": 130,
                      "enName": "Revenue After Refund & Tax($)",
                      "cnName": "净收入($)",
                      "rainbowKey": "Pc Revenue",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "revenue_after_chargeback",
                      "reqMetricKey": "revenue_after_chargeback",
                      "enPercentWidth": 270,
                      "cnPercentWidth": 190,
                      "enWidth": 270,
                      "cnWidth": 200,
                      "enName": "Revenue After Refund($)",
                      "cnName": "收入(剔除退款)($)",
                      "rainbowKey": "Pc Revenue After Refund($)",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "units_number",
                      "reqMetricKey": "units_number",
                      "enPercentWidth": 280,
                      "cnPercentWidth": 180,
                      "enWidth": 280,
                      "cnWidth": 155,
                      "enName": "Base Game Units After Refund",
                      "cnName": "本体拷贝净销量",
                      "rainbowKey": "Pc Units",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "gross_revenue",
                      "reqMetricKey": "gross_revenue",
                      "enPercentWidth": 210,
                      "cnPercentWidth": 160,
                      "enWidth": 160,
                      "cnWidth": 160,
                      "enName": "Revenue($)",
                      "cnName": "收入($)",
                      "rainbowKey": "Pc Gross Revenue",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "gross_full_game_units",
                      "reqMetricKey": "gross_full_game_units",
                      "enPercentWidth": 280,
                      "cnPercentWidth": 160,
                      "enWidth": 250,
                      "cnWidth": 160,
                      "enName": "Gross Base Game Units",
                      "cnName": "本体销量",
                      "rainbowKey": "Pc Gross Base Game Units",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "units_revenue",
                      "reqMetricKey": "units_revenue",
                      "enPercentWidth": 360,
                      "cnPercentWidth": 190,
                      "enWidth": 360,
                      "cnWidth": 140,
                      "enName": "Base Game Revenue After Refund & Tax($)",
                      "cnName": "本体拷贝收入($)",
                      "rainbowKey": "Pc Units Revenue",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "mtx_revenue",
                      "reqMetricKey": "mtx_revenue",
                      "enPercentWidth": 230,
                      "cnPercentWidth": 230,
                      "enWidth": 200,
                      "cnWidth": 140,
                      "enName": "In-Game Revenue($)",
                      "rainbowKey": "Pc In-Game Revenue($)",
                      "cnName": "内购收入($)",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "paid_users",
                      "reqMetricKey": "paid_users",
                      "enPercentWidth": 230,
                      "cnPercentWidth": 230,
                      "enWidth": 230,
                      "cnWidth": 140,
                      "enName": "Payer",
                      "cnName": "付费人数",
                      "rainbowKey": "Pc Payer",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "payer_rate",
                      "reqMetricKey": "payer_rate",
                      "enPercentWidth": 230,
                      "cnPercentWidth": 230,
                      "enWidth": 230,
                      "cnWidth": 140,
                      "enName": "Payer%",
                      "cnName": "付费渗透率",
                      "rainbowKey": "Pc Payer%",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "arpu",
                      "reqMetricKey": "arpu",
                      "enPercentWidth": 180,
                      "cnPercentWidth": 180,
                      "enWidth": 105,
                      "cnWidth": 110,
                      "enName": "ARPU($)",
                      "cnName": "活跃ARPU($)",
                      "rainbowKey": "ARPU($)",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "arppu",
                      "reqMetricKey": "arppu",
                      "enPercentWidth": 190,
                      "cnPercentWidth": 190,
                      "enWidth": 115,
                      "cnWidth": 150,
                      "enName": "ARPPU($)",
                      "cnName": "付费ARPPU($)",
                      "rainbowKey": "ARPPU($)",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "mtx_payers",
                      "reqMetricKey": "mtx_payers",
                      "enPercentWidth": 190,
                      "cnPercentWidth": 190,
                      "enWidth": 150,
                      "cnWidth": 110,
                      "enName": "In-Game Payer",
                      "cnName": "内购付费人数",
                      "rainbowKey": "Pc In-Game Payer",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "mtx_payer_rate",
                      "reqMetricKey": "mtx_payer_rate",
                      "enPercentWidth": 200,
                      "cnPercentWidth": 200,
                      "enWidth": 165,
                      "cnWidth": 150,
                      "enName": "In-Game Payer%",
                      "cnName": "内购付费渗透率",
                      "rainbowKey": "Pc In-Game Payer%",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "mtx_arpu",
                      "reqMetricKey": "mtx_arpu",
                      "enPercentWidth": 180,
                      "cnPercentWidth": 180,
                      "enWidth": 145,
                      "cnWidth": 110,
                      "enName": "In-Game ARPU",
                      "cnName": "内购ARPU",
                      "rainbowKey": "Pc In-Game ARPU",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "mtx_arppu",
                      "reqMetricKey": "mtx_arppu",
                      "enPercentWidth": 190,
                      "cnPercentWidth": 190,
                      "enWidth": 155,
                      "cnWidth": 150,
                      "enName": "In-Game ARPPU",
                      "cnName": "内购付费ARPPU",
                      "rainbowKey": "Pc In-Game ARPPU",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "digital_revenue",
                      "reqMetricKey": "digital_revenue",
                      "enPercentWidth": 230,
                      "cnPercentWidth": 230,
                      "enWidth": 230,
                      "cnWidth": 140,
                      "enName": "Digital Revenue",
                      "cnName": "线上收入",
                      "rainbowKey": "Pc Digital Revenue",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "physical_revenue",
                      "reqMetricKey": "physical_revenue",
                      "enPercentWidth": 230,
                      "cnPercentWidth": 230,
                      "enWidth": 230,
                      "cnWidth": 140,
                      "enName": "Physical Revenue",
                      "cnName": "线上收入",
                      "rainbowKey": "Pc Physical Revenue",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "d1",
                      "reqMetricKey": "d1",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 70,
                      "cnWidth": 80,
                      "enName": "D1",
                      "cnName": "D1留存",
                      "rainbowKey": "Pc D1",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 2
                    },
                    {
                      "metricKey": "d2",
                      "reqMetricKey": "d2",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 70,
                      "cnWidth": 80,
                      "enName": "D2",
                      "cnName": "D2留存",
                      "rainbowKey": "Pc D2",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 2
                    },
                    {
                      "metricKey": "d3",
                      "reqMetricKey": "d3",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 70,
                      "cnWidth": 80,
                      "enName": "D3",
                      "cnName": "D3留存",
                      "rainbowKey": "Pc D3",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 2
                    },
                    {
                      "metricKey": "d4",
                      "reqMetricKey": "d4",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 70,
                      "cnWidth": 80,
                      "enName": "D4",
                      "cnName": "D4留存",
                      "rainbowKey": "Pc D4",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 2
                    },
                    {
                      "metricKey": "d5",
                      "reqMetricKey": "d5",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 70,
                      "cnWidth": 80,
                      "enName": "D5",
                      "cnName": "D5留存",
                      "rainbowKey": "Pc D5",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 2
                    },
                    {
                      "metricKey": "d6",
                      "reqMetricKey": "d6",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 70,
                      "cnWidth": 80,
                      "enName": "D6",
                      "cnName": "D6留存",
                      "rainbowKey": "Pc D6",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 2
                    },
                    {
                      "metricKey": "d7",
                      "reqMetricKey": "d7",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 70,
                      "cnWidth": 80,
                      "enName": "D7",
                      "cnName": "D7留存",
                      "rainbowKey": "Pc D7",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 2
                    },
                    {
                      "metricKey": "d14",
                      "reqMetricKey": "d14",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 70,
                      "cnWidth": 100,
                      "enName": "D14",
                      "cnName": "D14留存",
                      "rainbowKey": "Pc D14",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 2
                    },
                    {
                      "metricKey": "d30",
                      "reqMetricKey": "d30",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 70,
                      "cnWidth": 100,
                      "enName": "D30",
                      "cnName": "D30留存",
                      "rainbowKey": "Pc D30",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 2
                    },
                    {
                      "metricKey": "pcu",
                      "reqMetricKey": "pcu",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 160,
                      "enWidth": 85,
                      "cnWidth": 122,
                      "enName": "PCU",
                      "cnName": "最高同时在线",
                      "rainbowKey": "PCU",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "acu",
                      "reqMetricKey": "acu",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 160,
                      "enWidth": 85,
                      "cnWidth": 122,
                      "enName": "ACU",
                      "cnName": "平均同时在线",
                      "rainbowKey": "ACU",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "aot_hour",
                      "reqMetricKey": "aot_hour",
                      "enPercentWidth": 166,
                      "cnPercentWidth": 166,
                      "enWidth": 176,
                      "cnWidth": 196,
                      "enName": "Avg.Playtime(h)",
                      "cnName": "平均在线时长(小时)",
                      "rainbowKey": "Pc Avg.Playtime(h)",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "alc",
                      "reqMetricKey": "alc",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 125,
                      "enWidth": 160,
                      "cnWidth": 125,
                      "enName": "Sessions per user",
                      "cnName": "平均登录次数",
                      "rainbowKey": "Pc Metrics Session",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "retention_users",
                      "reqMetricKey": "retention_users",
                      "enPercentWidth": 190,
                      "cnPercentWidth": 120,
                      "enWidth": 190,
                      "cnWidth": 120,
                      "enName": "DAU Retention Users",
                      "cnName": "日活留存",
                      "rainbowKey": "DAU Retention Users",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "churn_users",
                      "reqMetricKey": "churn_users",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 160,
                      "enWidth": 130,
                      "cnWidth": 100,
                      "enName": "Churn Users",
                      "cnName": "日流失",
                      "rainbowKey": "Churn Users",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "churn_rate",
                      "reqMetricKey": "churn_rate",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 80,
                      "cnWidth": 86,
                      "enName": "Churn%",
                      "cnName": "流失率",
                      "rainbowKey": "Churn%",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "return_users",
                      "reqMetricKey": "return_users",
                      "enPercentWidth": 180,
                      "cnPercentWidth": 170,
                      "enWidth": 160,
                      "cnWidth": 95,
                      "enName": "DAU Return Users",
                      "cnName": "日回流",
                      "rainbowKey": "DAU Return Users",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "weighted_d2",
                      "reqMetricKey": "weighted_d2",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 122,
                      "cnWidth": 122,
                      "enName": "Weighted D1",
                      "cnName": "加权D1留存",
                      "rainbowKey": "Weighted D1",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 2
                    },
                    {
                      "metricKey": "weighted_d3",
                      "reqMetricKey": "weighted_d3",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 122,
                      "cnWidth": 122,
                      "enName": "Weighted D2",
                      "cnName": "加权D2留存",
                      "rainbowKey": "Weighted D2",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "weighted_d7",
                      "reqMetricKey": "weighted_d7",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 122,
                      "cnWidth": 122,
                      "enName": "Weighted D6",
                      "cnName": "加权D6留存",
                      "rainbowKey": "Weighted D6",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "weighted_d14",
                      "reqMetricKey": "weighted_d14",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 132,
                      "cnWidth": 132,
                      "enName": "Weighted D13",
                      "cnName": "加权D13留存",
                      "rainbowKey": "Weighted D13",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "first_login_ratio",
                      "reqMetricKey": "first_login_ratio",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 145,
                      "enWidth": 160,
                      "cnWidth": 145,
                      "enName": "1st Order Login%",
                      "cnName": "一阶登录比",
                      "rainbowKey": "1st Order Login%",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "second_login_ratio",
                      "reqMetricKey": "second_login_ratio",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 145,
                      "enWidth": 160,
                      "cnWidth": 145,
                      "enName": "2nd Order Login%",
                      "cnName": "二阶登录比",
                      "rainbowKey": "2nd Order Login%",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    }
  ]
};